/**
 * Vuex module for contact tags
 */
import debug from 'debug'

const dbg = debug('store:contacts:detailDialog:')

const actions = {
  open ({ commit }, contact) {
    dbg('Open contact detail dialog')
    commit('OPEN_DIALOG', contact)
  },
  close ({ commit }) {
    dbg('Close contact detail dialog')
    commit('CLOSE_DIALOG')
  },
  setTag ({ commit }, contact) {
    commit('SET_TAG', contact)
  }
}

const mutations = {
  CLOSE_DIALOG (state) {
    state.contact = null
    state.isPersonal = false
    state.dialog = false
  },

  OPEN_DIALOG (state, contact) {
    state.dialog = true
    state.contact = contact
    state.isPersonal = contact.isPersonal
  },

  SET_TAG (state, contact) {
    state.contact = contact
  }
}

const state = {
  dialog: false,
  contact: null,
  isPersonal: false
}

const getters = {
  dialog: state => state.dialog,
  isPersonal: state => state.isPersonal,
  contact: state => state.contact
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
